var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { InView } from 'react-intersection-observer';
import { Box, Optional } from '@honda-canada/design-system-react';
import themeStyles from './TimelineSharedUI.styles';
import TimelineTextContent from './TimelineTextContent';
import TimelineMediaContent from './TimelineMediaContent';
import { TIMELINE_TEXT_ALIGNMENT, THRESHOLD_PERCENT_WHEN_VISIBLE } from './constants';
import { getHrefValue } from '../service/utils';
var ItemContainer = themeStyles.apply(Box, 'ItemContainer');
var TimelineItem = function (_a) {
    var year = _a.year, decadeValue = _a.decadeValue, item = _a.item, setCurrentYear = _a.setCurrentYear, _b = _a.isVisible, isVisible = _b === void 0 ? true : _b, _c = _a.ariaHidden, ariaHidden = _c === void 0 ? false : _c;
    var _d = item || {}, backgroundColor = _d.backgroundColor, bodyText = _d.bodyText, category = _d.category, subTitle = _d.subTitle, cta = _d.cta, textContentAlignment = _d.textContentAlignment, backgroundImage = _d.backgroundImage, title = _d.title, mediaImage = _d.mediaImage, videoUrl = _d.videoUrl;
    var src = (backgroundImage || {}).src;
    var toLowerCase = function (value) { return value === null || value === void 0 ? void 0 : value.toLocaleLowerCase(); };
    var contentAlignment = src ? TIMELINE_TEXT_ALIGNMENT.CENTER : toLowerCase(textContentAlignment);
    var ariaHiddenAttr = ariaHidden ? { 'aria-hidden': true } : {};
    return (React.createElement(InView, { onChange: function (inView) {
            if (inView && year) {
                setCurrentYear(year);
            }
        }, threshold: THRESHOLD_PERCENT_WHEN_VISIBLE, initialInView: false },
        React.createElement(ItemContainer, __assign({ "data-testid": "cy-timeline-content-".concat((year === null || year === void 0 ? void 0 : year.value) || ''), id: getHrefValue(decadeValue, year === null || year === void 0 ? void 0 : year.value), bgColor: toLowerCase(backgroundColor), containerImage: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src, textContentAlignment: contentAlignment, isVisible: isVisible }, ariaHiddenAttr),
            React.createElement(TimelineTextContent, { textContentAlignment: contentAlignment, cta: cta, bodyText: bodyText, category: category, subTitle: subTitle, title: title }),
            React.createElement(Optional, { when: !src },
                React.createElement(TimelineMediaContent, { mediaImage: mediaImage, videoUrl: videoUrl })))));
};
export default TimelineItem;
